import React, { useState, useRef } from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete } from '@mui/material';
import { FormHelperText, InputAdornment, InputLabel, TextField } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles, withStyles } from '@mui/styles';
import { LabelWithToolTip, Icons } from 'components';
import { LabelLine } from 'components/InputV2/components';
import businessListServices from './services/BusinessListServices';
import { useStyles } from './style';
import _ from 'lodash';
const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(1),
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
      padding: '1.5px 4px',
    },
    '& .MuiInputLabel-formControl': {
      top: '-7px',
      color: '#546e7a',
      fontSize: '12px',
    },
    '& .MuiInputAdornment-root': { color: '#546e7a' },
  },
}))(TextField);

const BusinessList = ({
  errors,
  control,
  name,
  defaultValue = null,
  required = false,
  label = 'نام کسب‌وکار',
  tooltip,
}) => {
  const classes = useStyles();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const delayedQuery = useRef(_.debounce((v, f) => f(v), 500)).current;
  const getList = async (val) => {
    if (val.length > 2) {
      if (list.length > 0) {
        const index = list.findIndex((item) => {
          return String(item?.name).search(val) > -1 || String(item?.id).search(val) > -1;
        });

        if (index > -1) {
          return;
        }
      }

      setLoading(true);

      const params = {};
      try {
        if (isNaN(val)) {
          params.query = val;
        } else {
          params.businessId = val;
        }

        const result = await businessListServices.getBusinessList(params);
        const data = result.result;

        if (data.length > 0) {
          const list = data.map((val) => ({
            name: val?.name,
            id: val?.id,
            userId: val?.userId,
          }));

          setList((prev) => [...prev, ...list]);
        }
      } catch (e) {
      }

      setLoading(false);
    }
  };

  return (
    <Controller
      name={name}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          style={{ marginTop: 0 }}
          disableClearable
          selectOnFocus
          onChange={(event, newValue) => {
            if (newValue) {
              onChange(newValue);
            }
          }}
          className={classes.root}
          onInputChange={(event, newInputValue) => {
            if (newInputValue) {
              delayedQuery(newInputValue, getList);
            }
          }}
          filterOptions={(options, params) => {
            const filtered = options.filter(
              (item) =>
                String(item?.id).search(params?.inputValue) > -1 ||
                String(item?.name).search(params?.inputValue) > -1,
            );

            return filtered;
          }}
          id="business-list"
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => option.name}
          options={list}
          value={value}
          loading={loading}
          renderInput={(params) => (
            <>
              <InputLabel shrink htmlFor={params?.name} className={classes.label}>
                <LabelLine
                  label={<LabelWithToolTip label={label} description={tooltip} />}
                  required={required}
                />
              </InputLabel>
              <BootstrapInput
                {...params}
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading && <CircularProgress color="inherit" size={20} />}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icons icon='Search' color='#667585' hover='#667585' size='20' />
                    </InputAdornment>
                  ),
                }}
              />
              {/* {hasError && ( */}
              <FormHelperText id="my-helper-text" className={classes.asterisk}>
                {errors?.[name]?.message}
              </FormHelperText>
              {/* )} */}
            </>
          )}
        />
      )}
      control={control}
      rules={{
        required: required ? 'فیلد نام کسب‌وکار الزامی است.' : required,
      }}
      defaultValue={defaultValue}
    />
  );
};

export default BusinessList;
